export const residentialPage = {
  hero: {
    eyebrow: 'Residential landscapes & outdoor living',
    title: 'Make more of the place you call home.',
    intro:
      'Bring planting, stonework and outdoor living together in a landscape made for the way you enjoy your property. Create a new garden, refresh an established landscape or make room to gather outdoors.',
    primary: { label: 'Tell us about your property', href: '/contact' },
    secondary: { label: 'Explore selected projects', href: '/gallery' },
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/landscape-hero.png',
    alt: 'A landscaped home with a limestone walkway and layered garden planting.',
  },
  overview: {
    eyebrow: 'Planned together',
    title: 'A landscape that feels connected.',
    text: 'A garden, an entry walk and a place to sit should work together. D.A. Alexander combines landscape design and installation with hardscape and outdoor features, so the different parts of your property feel like one considered space.',
    groups: [
      {
        title: 'Landscape foundations',
        links: [
          { label: 'Landscape design & installation', href: '#landscape-design-installation' },
          { label: 'Landscape renovation', href: '#landscape-renovation' },
          { label: 'Brick pavers & hardscape', href: '#hardscape' },
        ],
      },
      {
        title: 'Garden features',
        links: [
          { label: 'Outdoor kitchens & living areas', href: '#outdoor-living' },
          { label: 'Fireplaces & fire pits', href: '#fire-features' },
          { label: 'Outdoor lighting', href: '#outdoor-lighting' },
        ],
      },
    ],
  },
  details: {
    title: 'Start fresh, or build on what you already love.',
    items: [
      {
        id: 'landscape-design-installation',
        title: 'Landscape design & installation',
        text: 'Shape a new outdoor setting with trees, shrubs, perennial planting and thoughtfully placed landscape features. Bring the front and back of your property into a plan that suits your home.',
      },
      {
        id: 'landscape-renovation',
        title: 'Landscape renovation',
        text: 'Refresh overgrown planting, rework an entrance or replace a worn path or retaining wall. An established landscape can keep its character while becoming more useful and inviting.',
      },
      {
        id: 'hardscape',
        title: 'Brick pavers & hardscape',
        text: 'Connect the landscape with patios, walkways, steps and retaining walls. Brick pavers and natural stone create places to move, sit and gather.',
      },
    ],
  },
  outdoorLiving: {
    title: 'Make room for the moments outdoors.',
    text: 'An outdoor kitchen or grilling area, a fire feature and landscape lighting can make time outside more enjoyable. Bring these features into the wider garden and hardscape plan rather than treating them as separate additions.',
    labels: [
      { id: 'outdoor-kitchens', label: 'Outdoor kitchens & living areas' },
      { id: 'fire-features', label: 'Fireplaces & fire pits' },
      { id: 'outdoor-lighting', label: 'Outdoor lighting' },
    ],
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/project-garden.png',
    alt: 'A garden entry with a brick-paver path framed by planting beds.',
  },
  proof: {
    eyebrow: 'Recognized residential work',
    title: 'See the craftsmanship in the landscape.',
    description: 'Natural stone steps, a stepping-stone path and layered planting bring this wooded Northville garden together. The project received an MGIA Bronze Award for Residential Landscape Re-Construction in 2019.',
    invitation: 'Thinking about a new garden, a refreshed entry or a more inviting place to gather? Tell us what you would like to change at home.',
    action: { label: 'Discuss your landscape', href: '#service-inquiry' },
    label: 'Northville · 2019',
    caption: 'MGIA Bronze Award · Residential Landscape Re-Construction',
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/northville-logo-cleaned-20261029.png',
    alt: 'Natural stone steps and a stepping-stone path beside a wooded Northville home.',
    link: { label: 'View award-winning projects', href: '/awards' },
  },
  closing: {
    title: 'What would you like to create at home?',
    text: 'Tell us about your property and the changes you have in mind. We can help you find the right place to start.',
    action: { label: 'Start your project', href: '/contact' },
    location: 'Based in Livonia. Serving southeast Michigan.',
  },
};
